export const OfferTypes = {
  product: 'product',
  package: 'package',
  gift: 'gift',
}